<template>

    <div>
	
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ label }}</span>
            </div>
            <div class="custom-file">
                <input type="file" class="custom-file-input" ref="inputfile" :name="name" :accept="accept" @change="onFileChange($event)">
                <label class="custom-file-label">{{ input_label }}</label>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data() {
            return {
            	input_label: '',
                show_preview: false,
            }
        },
        props: {
            id: {required: false},
        	accept: {required: false},
        	btn_label: {required: true},
        	label: {required: true},
            name: {required: true},
        },
        created() {
            window.Event.$on('reset-input-file', this.reset);
        },
        mounted() {
        	this.input_label = this.btn_label;
        },
        methods: {
            onFileChange(e) {
            	this.input_label = file.name;

                window.Event.$emit('on-file-change', e);
            },
            reset(id){
                if(this.id && this.id == id && this.$refs.inputfile){
                    this.$refs.inputfile.value = null;
                    this.input_label = '';
                    this.src = null;
                    this.show_preview = false;
                }
            }
        }
    }
</script>